var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3a9b9de3701168bcf9447b470a9aaa72.svg#bj';
                    var viewUrl = 'sprites.3a9b9de3701168bcf9447b470a9aaa72.svg#view-bj';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };